import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { generateIdDocument, setDocument } from '../../../../../firebase/firestore'
import { Path } from '../../../../../router/paths'
import { DateTimeNow } from '../../../../../utils/dates'
import { TryCatch } from '../../../../../utils/general'
import { useGlobalContext } from '../../../../../context/ContextGlobal'
import { createSchemaPlans } from '../utils'

export const useClientAddPlans = () => {
  const {
    user,
    setAlerts,
    loading,
    setLoading,
    // dataContext,
    // setDataContext, // contexto que guarda dados de lista para a pagina
    // infosContext,
    // setInfosContext, // contexto que guarda dados adicionais para a pagina funcionar
    formContext,
    setFormContext, // contexto que guarda dados de formularios da pagina
  } = useGlobalContext()

  const navigate = useNavigate()

  const getForm = () => {
    setFormContext({
      typePlan: 'collab',
      typeValue: 'amount',
      value: '0',
      admission: '0',
      payment: 'pix',
      typeExpired: '30',
      trialDays: 0,
    })
  }

  const FetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  const addPlan = async () => {
    const newIdPlan = await generateIdDocument('plans')

    // let createPlanOmie = { nCodServ: '' }
    // const createPlanPagBank = false
    // const createCouponPagBank = false

    // const newPlanOmie = createSchemaPlansOmie({ ...formContext, id: newIdPlan })

    // try {
    //   createPlanOmie = await ServicesOmie().IncluirServico([{ ...newPlanOmie }])
    // } catch (error) {
    //   // throw new Error(error.message)
    // }

    // if (!createPlanOmie) return

    // if (formContext?.typePlan === 'coupon') {
    //   const newCouponPagBank = CreateSchemaCouponPagBank({ ...formContext, id: newIdPlan })

    //   try {
    //     createCouponPagBank = await PagBankCoupon().add(newCouponPagBank)
    //   } catch (error) {
    //     throw new Error(error.message)
    //   }
    // }
    // if (formContext?.payment === 'credito') {
    //   const newPlanPagBank = CreateSchemaPlansPagBank({ ...formContext, id: newIdPlan })
    //   try {
    //     createPlanPagBank = await PagBankPlans().add(newPlanPagBank)
    //   } catch (error) {
    //     // console.log(error.message)
    //     throw new Error(error.message)
    //   }

    //   if (!createPlanPagBank) return
    // }

    // cria plano no pagseguro se for crédito recorrente

    // console.log(createPlanPagBank)c

    const newPlan = {
      ...createSchemaPlans(formContext),
      // idOmie: createPlanOmie.nCodServ,
      // idPagBank: createPlanPagBank?.id || createCouponPagBank?.id || '',
      created_by: user?.user?.nome,
      dt_created: DateTimeNow(),
    }
    await setDocument('plans', newIdPlan, newPlan)

    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Plano Criado',
        msg: 'Novo Plano criado com sucesso.',
      },
    ])
    navigate(Path.APlanos)
    return navigate(Path.AdminPlans)
  }

  const HandleAddPlan = async () => {
    await TryCatch(addPlan, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetForm()
  }, [])

  return {
    loading,
    formContext,
    setFormContext,
    HandleAddPlan,
  }
}
